module.exports = __webpack_public_path__ + "img/slim_cleanstation01.9be1d764.jpg";